import { render, staticRenderFns } from "./AssistenciaFuneral.vue?vue&type=template&id=d131aaca&scoped=true&"
import script from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
export * from "./AssistenciaFuneral.vue?vue&type=script&lang=js&"
import style0 from "./AssistenciaFuneral.vue?vue&type=style&index=0&id=d131aaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d131aaca",
  null
  
)

export default component.exports